import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Btn = styled.button`
  color: ${props => props.theme.colors.propertyColor};
  font-size: 12px;
  background-color: #fff;
  transition: all 0.2s ease-in;
  padding: 0 12px;
  cursor: pointer;
  height: 32px;
  border: none;
  outline: none;
  box-shadow: none;
  display: flex;
  align-items: center;

  span {
    margin-right: 3px;
  }
`;

export const Form = styled(Flex).attrs({
  as: 'form',
  align: 'center',
})`
  height: 32px;
  outline: none;
  overflow: hidden;
  margin: 5px 0;
  border: 1px solid ${props => props.theme.colors.propertyColor};
  border-radius: 50px;
  margin-left: 10px;

  & > {
    &:not(:last-child) {
      border-right: 1px solid ${props => props.theme.colors.propertyColor};
    }
  }
`;

export const InputWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  font-size: 12px;
  height: 32px;

  input {
    font-size: 12px;
    text-align: center;
    padding: 4px;
    height: 100%;
    max-width: 45px;
    border: none;
    border-radius: 0;
    box-shadow: none !important;
    outline: none !important;
  }
`;
